module.exports = __webpack_public_path__ + "img/tu2.6bf4e5c9.png";